export default __webpack_public_path__ + "static/media/future_transparent.6cb27fa8.webp";